import React from 'react';
import './AttendanceTag.less';
import attendanceNote from '../../images/attendanceNote.svg';
import { TagTypes, AttendanceTagTypes } from '../../types';

export type AttendanceTagProps = {
  type: TagTypes;
  size: AttendanceTagTypes;
  note: Boolean;
};

const TAttendanceTag: React.FC<AttendanceTagProps> = ({
  children,
  size = 'md',
  type = 'positive',
  note = false,
  ...props
}) => {
  const classNames = ['t-attendanceTag', `t-attendanceTag-${type}`];
  const sizes = {
    sm: { minWidth: 20, mineight: 20 },
    md: { minWidth: 24, height: 24 },
    lg: { minWidth: 36, height: 36 },
  };

  return (
    <span style={sizes[size]} className={classNames.join(' ')} {...props}>
      {!!note && (
        <img className="t-note-indicator" alt="note" src={attendanceNote} />
      )}
      {children}
    </span>
  );
};

export default TAttendanceTag;
